import BarChart from "@rio-cloud/rio-uikit/BarChart";
import Bar from "@rio-cloud/rio-uikit/Bar";
import { Loading } from "../../../utils/loading";

interface IRepairIndicators {
  barChartData: {
    name: string;
    value: number;
  }[];
  formatValue?: (value: number) => string;
  onBarClick?: (element: any) => void;
}

const RepairIndicators = (props: IRepairIndicators) => {
  const { barChartData, formatValue, onBarClick } = props;
  return (
    <div className="margin-bottom-0 min-w-[1500px] h-[170px]">
      <BarChart
        data={barChartData}
        dataKey="name"
        xAxisOptions={{ dataKey: "name" }}
        showYAxis={false}
        useDataColors
        margin={{ bottom: -12, top: 35 }}
        tooltip={false}
        style={{
          color: "#666666",
          fontSize: 10,
          fontWeight: 600,
        }}
        bars={[
          <Bar
            key="bar"
            isAnimationActive={false}
            dataKey="value"
            radius={[3, 3, 0, 0]}
            label={{
              position: "top",
              formatter: (value: number) =>
                formatValue ? formatValue(value) : value,
              fontSize: 14,
              fill: "#808080",
              fontWeight: 500,
            }}
            barSize={60}
            onClick={onBarClick}
          />,
        ]}
      />
    </div>
  );
};

export default RepairIndicators;
